import { List } from "@mantine/core";
import { useTranslation } from "react-i18next";

export const SchoolFeatures = () => {
    const { t } = useTranslation(["common"]);

    return (
        <>
            <List>
                <List.Item>{t("upgrade.schools.all-of-the-above")}</List.Item>
                <List.Item>{t("upgrade.schools.dpa")}</List.Item>
            </List>
            <br />
            <List>
                <List.Item>{t("upgrade.schools.free-trial")}</List.Item>
                <List.Item>{t("upgrade.schools.multiple-users")}</List.Item>
            </List>
        </>
    );
};
